import { toPoint } from 'mgrs';
import type { ParsedCoordinates } from './types';
import { upsMgrsToLatLng } from './ups';

/** MGRS, incl. polar (UPS) squares. `compact` is upper case without whitespace. */
export function parseMgrs(compact: string): ParsedCoordinates | null {
  let m = compact.match(/^(\d{1,2})([C-HJ-NP-X])([A-HJ-NP-Z])([A-HJ-NP-V])(\d{0,10})$/);
  if (m && m[5].length % 2 === 0 && Number(m[1]) >= 1 && Number(m[1]) <= 60) {
    try {
      const [lng, lat] = toPoint(compact);
      if (isFinite(lat) && isFinite(lng)) return { lat, lng, format: 'mgrs' };
    } catch {
      // not a valid MGRS square
    }
  }
  m = compact.match(/^([ABYZ])([A-HJ-NP-Z])([A-HJ-NP-Z])(\d{0,10})$/);
  if (m && m[4].length % 2 === 0) {
    const p = upsMgrsToLatLng(m[1] as 'A' | 'B' | 'Y' | 'Z', m[2], m[3], m[4]);
    if (p) return { ...p, format: 'mgrsPolar' };
  }
  return null;
}

/** UTM like "12T 445123 4476890" or "12T 445123mE 4476890mN". */
export function parseUtmText(text: string) {
  const m = text
    .toUpperCase()
    .trim()
    .match(/^(\d{1,2})\s*([C-HJ-NP-X])\s+(\d{1,7}(?:\.\d+)?)\s*M?E?[\s,]+(\d{1,8}(?:\.\d+)?)\s*M?N?$/);
  if (!m || Number(m[1]) < 1 || Number(m[1]) > 60) return null;
  return { zone: Number(m[1]), south: m[2] < 'N', easting: Number(m[3]), northing: Number(m[4]) };
}
